<template>
	<div id="daumWrap" class="cafe_type3" v-show="ready">
		<header id="daumHead" class="daum_head daum_head--fixed">
			<div class="cafe_head">
				<h1 class="sr_only">{{grpname}}</h1>
				<div class="cafe_navi cafe_navi_type1" id="cafe_navi_default">
					<h2 class="tit_calendar">
						<span class="ico_cafe ico_calendar">cafe 캘린더</span>
					</h2>
					<close-button></close-button>
					<h3 class="sr_only">설정</h3>
					<div class="calendar_setting">
						<button @click="onAlarmClick" class="ico_cafe ico_alarm">알림</button>
						<category-select></category-select>
						<today-button></today-button>
					</div>
				</div>
			</div>
		</header>
		<main id="daumContent" class="cont_schedule">
			<article id="mArticle" :class="articleClass" v-cloak>
				<fold-button>{{monthText}}</fold-button>
				<div class="calendar_wrapper" v-hammer:pan="onPan" :style="swiperStyle">
					<calendar v-if="!isFolded" :year="year" :month="month-1"></calendar>
					<calendar v-if="!isFolded" :is-center="true" :year="year" :month="month"
							  @calendar-length-change="onCalendarLengthChange"></calendar>
					<calendar v-if="!isFolded" :year="year" :month="month+1"></calendar>
				</div>
				<h3 class="sr_only">스케줄 목록</h3>
				<div class="schedule_list" ref="scheduleList">
					<p v-if="isEmpty" class="desc_none">해당 월에 등록된 일정이 없습니다.</p>
					<template v-else>
						<daily-schedule v-for="dailySchedules in currentSchedules" v-if="dailySchedules[1].length"
							:date="dailySchedules[0]" :schedules="dailySchedules[1]"></daily-schedule>
						<img src="//t1.daumcdn.net/cafe_image/mobile/flags/ico_kor_flag.png" :class="flagClass" alt="한국국기">
					</template>
				</div>
				<add-button v-if="isAdmin" :calendar-id="calendarId"></add-button>
			</article>
		</main>
	</div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';

	import { format } from 'date-fns';

	import Vue from 'vue';
	import { VueHammer } from 'vue2-hammer';

	import CloseButton from './components/CloseButton.vue';
	import CategorySelect from './components/CategorySelect.vue';
	import TodayButton from './components/TodayButton.vue';

	import FoldButton from './components/FoldButton.vue';
	import Calendar from './components/Calendar.vue';

	import DailySchedule from './components/DailySchedule.vue';

	import AddButton from './components/AddButton.vue';

	Vue.use(VueHammer);

	const WAIT_TIME = 100;
	const TRANSLATION_UNIT = 100;

	export default {
		components: {
			CloseButton, CategorySelect, TodayButton,
			FoldButton, Calendar,
			DailySchedule,
			AddButton,
		},

		data() {
			return {
				grpname: CAFEAPP.GRPNAME,

				longerThanScreen: false,

				ready: false,
				isAdmin: IS_ADMIN,

				isFinal: false,
				translation: -TRANSLATION_UNIT,
				isCalendarLong: false,

				scroll: 0,
			};
		},
		computed: {
			...mapState(['isFolded', 'date', 'calendarId']),
			...mapGetters(['currentSchedules', 'isFirstMonth', 'isLastMonth']),
			year() {
				return this.date.getFullYear();
			},
			month() {
				return this.date.getMonth();
			},
			monthText() {
				return format(this.date, 'yyyy.MM.');
			},

			isEmpty() {
				return Object.keys(this.currentSchedules).length === 0;
			},

			articleClass() {
				return {
					schedule_container: true,
					fold: this.isFolded,
					none_schedule: this.isEmpty,
					long_calendar: !this.isFolded && this.isCalendarLong,
				};
			},
			flagClass() {
				return ['schedule_lang_flag', this.longerThanScreen ? '' : 'fixed_flag'];
			},
			swiperStyle() {
				return {
					translation: `transform ${this.isFinal ? WAIT_TIME : 0}ms`,
					transform: `translateX(${this.translation}vw)`,
				}
			},

			targetId() {
				const validDates = this.currentSchedules.map(v => v[0]);
				let last, i;

				for (i=0; i<validDates.length; i++) {
					last = validDates[i];
					if (validDates[i] >= format(this.date, 'yyyy-MM-dd'))
						break;
				}

				return `date-${last}`;
			},
		},

		methods: {
			...mapActions(['initCalendar', 'increaseMonth', 'decreaseMonth']),
			onAlarmClick() {
				const appScheme = `daumcafe://schedule?grpcode=${CAFEAPP.GRPCODE}&fldid=${CAFEAPP.FLDID}&type=list`;

				if (window.confirm('스케줄 등록·수정·삭제 시 알림을 받을 수 있는 다음카페앱으로 이동할까요?')) {
					Utils.web2app(appScheme);
				}
			},
			timeout(ms) {
				return new Promise(resolve => setTimeout(resolve, ms));
			},
			async onPan(e) {
				const THRESHOLD = 20;
				const difference = e.deltaX / window.innerWidth * TRANSLATION_UNIT;
				const ms = WAIT_TIME;

				if (e.isFinal) {
					this.isFinal = true;

					if (difference > THRESHOLD && !this.isFirstMonth) {
						this.translation = 0;
						await this.timeout(ms);
						this.decreaseMonth();
					} else if (difference < -THRESHOLD && !this.isLastMonth) {
						this.translation = -200;
						await this.timeout(ms);
						this.increaseMonth();
					} else {
						this.translation = -TRANSLATION_UNIT;
						await this.timeout(ms);
					}

					this.isFinal = false;
					this.translation = -TRANSLATION_UNIT;
				} else {
					this.translation = -TRANSLATION_UNIT + difference;
				}
			},
			onCalendarLengthChange(length) {
				this.isCalendarLong = length === 6;
			},

			attachPopStateEvent() {
				const isUnderKitkat = /Android [1-4]\./.test(navigator.userAgent); // version <= 4.4
				const isSafari = !/Chrome|Firefox/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent);

				if (isUnderKitkat) {
					return;
				}

				history.pushState(null, null, window.location.href);

				window.addEventListener('popstate', function (e) {
					if (isSafari && sessionStorage.getItem('fromAnotherPage')) {
						sessionStorage.removeItem('fromAnotherPage');
						return;
					}

					sessionStorage.removeItem('date');
					sessionStorage.removeItem('scroll');
					sessionStorage.removeItem('fold');
					sessionStorage.removeItem('category');
					sessionStorage.removeItem('fromAnotherPage');

					history.back();
				}, false);
			},
		},
		watch: {
			date() {
				setTimeout(() => {
					const target = document.getElementById(this.targetId);
					if (!target) return;
					this.scroll = Math.max(target.offsetTop - 15, 1);
				}, WAIT_TIME);
			},
			scroll(scroll) {
				this.$refs.scheduleList.scroll({top: scroll});
				sessionStorage.setItem('scroll', scroll);
			},
		},

		async created() {
			await this.initCalendar();
			this.ready = true;
			setTimeout(() => {
				const scroll = sessionStorage.getItem('scroll');
				this.scroll = scroll ? parseInt(scroll) : 1;
			}, WAIT_TIME);

			const scheduleList = this.$refs.scheduleList;
			scheduleList.addEventListener('scroll', () => {
				sessionStorage.setItem('scroll', scheduleList.scrollTop);
			});

			this.attachPopStateEvent();
		},
		updated() {
			const scheduleList = this.$refs.scheduleList;
			this.longerThanScreen = scheduleList.scrollHeight > scheduleList.clientHeight;
		},
	}
</script>
